/* esm.sh - @radix-ui/react-radio-group@1.3.8 */
export * from "/*@radix-ui/react-radio-group@1.3.8/esnext/react-radio-group.mjs";
